import { useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import './QuizItem.css'

const QuizItem = ({
  question_title,
  option_a,
  option_b,
  option_c,
  option_d,
  section,
  id,
}) => {
  const [optionChosen, setOptionChosen] = useState({
    option_a: '',
    option_b: '',
    option_c: '',
    option_d: '',
  })

  const missed_entries = useSelector((state) => state.quiz.missed_entries)

  const chooseOption = (option) => {
    for (const [key] of Object.entries(optionChosen)) {
      if (key === option) {
        setOptionChosen((prev) => ({
          ...prev,
          [option]: 'chosen',
        }))
      } else {
        setOptionChosen((prev) => ({
          ...prev,
          [key]: '',
        }))
      }
    }

    localStorage.setItem(
      'result',
      JSON.stringify({
        ...JSON.parse(localStorage.getItem('result')),
        [id]: { option, section },
      })
    )
  }

  useEffect(() => {
    if (!localStorage.getItem('result')) {
      return
    }
    if (JSON.parse(localStorage.getItem('result')).hasOwnProperty(id)) {
      setOptionChosen((prev) => ({
        ...prev,
        [JSON.parse(localStorage.getItem('result'))[id].option]: 'chosen',
      }))
    }
  }, [])

  return (
    <div className='quiz__content__body'>
      <div className='quiz__content__question'>
        <h3
          style={{ color: `${missed_entries.includes(id) ? 'red' : 'black'}` }}
        >
          {question_title} <span style={{ color: 'red' }}>*</span>
        </h3>
      </div>
      <div className='quiz__content__question-bank'>
        <div
          className={`quiz__content__option ${optionChosen.option_a}`}
          onClick={() => chooseOption('option_a')}
        >
          <p>{option_a}</p>
        </div>
        <div
          className={`quiz__content__option ${optionChosen.option_b}`}
          onClick={() => chooseOption('option_b')}
        >
          <p>{option_b}</p>
        </div>
        <div
          className={`quiz__content__option ${optionChosen.option_c}`}
          onClick={() => chooseOption('option_c')}
        >
          <p>{option_c}</p>
        </div>
        <div
          className={`quiz__content__option ${optionChosen.option_d}`}
          onClick={() => chooseOption('option_d')}
        >
          <p>{option_d}</p>
        </div>
      </div>
    </div>
  )
}

export default QuizItem
